import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Navigate } from 'react-router';
import { makeLinks, withRouter } from 'utils/common';
import { partial } from 'underscore';
import axios from 'axios';
import moment from 'moment';
import endpoints from 'utils/endpoints';
import PersonalData from './Pages/PersonalData';
import Summary from './Pages/Summary';
import PaymentSuccess from 'components/PaymentSuccess';
import PaymentError from 'components/PaymentError';
import Head from 'components/Head';
import i18n from 'utils/translate';
import { getQueryStringParams } from 'utils/common';
import { PAYMENT_RESPONSE } from 'utils/constants';
import { insertAfter, isAustrianIBAN } from 'utils/common';
import { animateScroll } from 'react-scroll';
import initTranslationsMK from './translations_mk';
import './styles.scss';

import { DATA_STORAGE_KEY, PAYMENT_STORAGE_KEY } from './constants';

class PaymentFormMkContainer extends Component {
  constructor(props) {
    super(props);

    initTranslationsMK();

    const { location } = props;
    const steps = [
      { text: i18n('Ihre Daten'), url: '' },
      { text: i18n('Bestätigung'), url: 'summary' }
    ];

    this.params = {};
    this.ajaxLoading = false;
    this.blockPayment = false;

    this.state = {
      loading: false,
      apiErrorMessages: [],
      restored: false
    };

    if (location.pathname.indexOf('/summary') === -1) {
      sessionStorage.clear();
    }

    this.initializeData();

    this.steps = steps.map(step => ({
      ...step,
      path: `${step.path}`
    }));

    this.urls = {
      personal: '/',
      summary: '/summary',
      success: '/success',
      error: '/error'
    };
  }

  initializeData = () => {
    const params = getQueryStringParams();

    this.data = {
      personal: {
        paymentReference: params.ref || '',
        premium: params.premium || ''
      }
    };
  };

  componentDidMount() {
    // Restore data (if any) from temporary storage
    const frozen = sessionStorage.getItem(DATA_STORAGE_KEY);
    if (frozen === null) {
      this.setState({
        restored: true
      });
      return;
    }
    try {
      const data = JSON.parse(frozen);
      this.data = data;

      this.setState({ ...data, restored: true });
    } catch (e) {
      // Nothing to do here: this was an optional op
    }
  }

  updateData = (key, value) => {
    this.data[key] = value;
    this.setState({ [key]: value });
  };

  resetApiErrors = () => {
    this.setState({
      apiErrorMessages: []
    });
  };

  storeTemporarily() {
    // store data to be temporarily picked up by re-navigation
    const frozen = JSON.stringify(this.data);
    sessionStorage.setItem(DATA_STORAGE_KEY, frozen);
  }

  makeOrderModel() {
    const {
      personal: { firstname, lastname, paymentReference, premium, email, birthdate, type, iban, bic }
    } = this.data;

    const prefix = window.base === '/' ? '' : window.base;

    return {
      versicherter: {
        anrede: 0,
        vorname: firstname,
        nachname: lastname,
        geburtsdatum: moment(birthdate).format('DD.MM.YYYY'),
        email: email
      },
      zahlungsReferenz: paymentReference,
      praemie: premium,
      bezahlung: {
        type: type === 'sepa' ? 'sepa' : 'hobex',
        hobexRequestUrl: type === 'sepa' ? undefined : `${window.location.origin}${prefix}/summary/`,
        iban: type === 'sepa' ? iban.replace(/\s+/g, '') : undefined,
        bic: type === 'sepa' ? (isAustrianIBAN(iban) ? '' : bic) : undefined,
        paymentMethod: type === 'sepa' ? 'SEPA_DIRECTDEBITMANDATE' : 'CREDITCARD',
        betrag: premium,
        waehrung: 'EUR'
      }
    };
  }

  placeCreditCardOrder() {
    const data = this.makeOrderModel();
    this.storeTemporarily();

    return axios({
      baseURL: GRAWE.api_root_mk,
      url: endpoints.paymentFormMk.HOBEX_ORDER,
      method: 'post',
      data,
      withCredentials: true,
      crossdomain: true
    })
      .then(resp => {
        if (resp.data.ok) {
          this.data.documents = {
            ...resp.data
          };

          this.storeTemporarily();
          setTimeout(() => {
            //window.location = resp.data.hobexUrl
            console.debug('GRAWE response:', resp.data);
            const confirmationPage = document.getElementById('payment-summary');

            let widgetWrapper = document.createElement('div');
            widgetWrapper.setAttribute('id', 'widgetWrapper');

            let hobexWidgetOptions = document.createElement('script');
            hobexWidgetOptions.text = 'var wpwlOptions = {locale: "de"}';

            let hobexWidget = document.createElement('script');
            hobexWidget.src = resp.data.hobexUrl;

            let hobexForm = document.createElement('form');
            hobexForm.classList.add('paymentWidgets');
            hobexForm.setAttribute('data-brands', 'MASTER VISA');
            hobexForm.action = window.location.href + '?callback=' + resp.data.actionUrl;

            confirmationPage.classList.add('hidden');
            animateScroll.scrollToTop({ duration: 0 });
            widgetWrapper.appendChild(hobexWidgetOptions);
            widgetWrapper.appendChild(hobexWidget);
            widgetWrapper.appendChild(hobexForm);
            insertAfter(widgetWrapper, confirmationPage);
            window.onpopstate = function (event) {
              const widgetWrapperEl = document.getElementById('widgetWrapper');
              widgetWrapperEl && widgetWrapperEl.remove();
            };
          });
          this.setState({
            loading: false
          });
        } else {
          this.setState({
            loading: false,
            apiErrorMessages: [
              {
                validierungsText: `${i18n('Kreditkartenzahlung fehlgeschlagen')}`
              }
            ]
          });
        }
      })
      .catch(error => {
        this.setState({
          loading: false,
          apiErrorMessages: [
            {
              validierungsText: `${i18n('Kreditkartenzahlung fehlgeschlagen')}`
            }
          ]
        });
      });
  }

  placeSepaOrder() {
    const data = this.makeOrderModel();
    const { navigate } = this.props.router;

    return axios({
      baseURL: GRAWE.api_root_mk,
      url: endpoints.paymentFormMk.SEPA,
      method: 'post',
      data
    })
      .then(resp => resp.data)
      .then(
        ({ validierungsMeldungen: errors, status }) => {
          if (status === PAYMENT_RESPONSE.ERROR) {
            const apiErrors = [{ validierungsText: `${i18n('SEPA-Zahlung fehlgeschlagen')}` }];
            this.setState({
              apiErrorMessages: apiErrors,
              status: status
            });
          } else {
            this.setState({
              status: status
            });
            this.data.success = true;
            navigate('/success');
          }
          this.setState({
            loading: false
          });
        },
        () => {
          this.setState({
            loading: false,
            apiErrorMessages: [{ validierungsText: `${i18n('SEPA-Zahlung fehlgeschlagen')}` }]
          });
        }
      );
  }

  placeOrder = () => {
    const {
      personal: { type: payment_type }
    } = this.data;

    const { loading } = this.state;

    if (loading) {
      console.debug('Place order: Alreday in progress');
      return;
    }

    this.setState(
      {
        loading: true
      },
      () => {
        if (payment_type === 'sepa') {
          this.placeSepaOrder();
        } else {
          this.placeCreditCardOrder();
        }
      }
    );
  };

  makeLinks(previous, current, next) {
    const { navigate, location } = this.props.router;

    return makeLinks(previous, current, next, navigate, location);
  }

  handleCreditCardPayment = (params, storno = false) => {
    const url = GRAWE.api_root_mk + decodeURIComponent(params.callback);

    if (window.dataLayer) {
      window.dataLayer.push({
        ecommerce: {
          purchase: {
            actionField: {
              id: this.data.personal.paymentReference,
              affiliation: 'PaymentFormMacedonia',
              revenue: this.data.personal.premium
            },
            products: [
              {
                name: 'OnlinePremiumPaymentMK',
                price: this.data.personal.premium,
                category: 'PaymentFormMacedonia',
                variant: 'Folgepraemie',
                quantity: 1
              }
            ]
          }
        }
      });
    }

    return axios({
      url,
      withCredentials: true
    });
  };

  renderPersonalDetailsPage = () => {
    const props = {
      ...this.makeLinks(null, this.urls.personal, this.urls.summary),
      onChange: partial(this.updateData, 'personal'),
      data: this.data.personal
    };

    return <PersonalData {...props} />;
  };

  renderSummaryPage = () => {
    const { navigate } = this.props.router;
    let errorMessages = [];

    // paymentReference and premium are always included
    const { paymentReference, premium, ...formData } = this.data.personal;
    if (!Object.keys(formData).length) {
      return <Navigate replace to={this.urls.personal} />;
    }

    if (window.location.hash.indexOf('callback') > 0) {
      if (
        !sessionStorage.getItem(DATA_STORAGE_KEY) ||
        (!this.ajaxLoading && JSON.parse(sessionStorage.getItem(PAYMENT_STORAGE_KEY)))
      ) {
        sessionStorage.clear();
        this.initializeData();
        return <Navigate replace to={this.urls.personal} />;
      }

      this.params = getQueryStringParams();
      const hash = window.location.hash;
      // extract string between ? and first =, this should be the first param
      this.paramsFirst = hash.substring(hash.indexOf('?') + 1, hash.indexOf('='));

      if (this.paramsFirst === 'callback' && !this.ajaxLoading) {
        this.ajaxLoading = true;
        sessionStorage.setItem(PAYMENT_STORAGE_KEY, true);
        this.handleCreditCardPayment(this.params).then(
          ({ data }) => {
            if (
              (data.ok && data.status === PAYMENT_RESPONSE.SUCCESS) ||
              (data.ok && data.status === PAYMENT_RESPONSE.REVEIW) ||
              (data.ok && data.status === PAYMENT_RESPONSE.INITIATED)
            ) {
              let widget = document.getElementById('widgetWrapper');
              if (widget) {
                widget.remove();
              }
              this.setState({
                apiErrorMessages: [],
                documents: {
                  bestellID: data.bestellID
                },
                status: data.status
              });
              console.debug('Success: payment response data:', data);
              this.data.success = true;
              navigate('/success');
            } else {
              sessionStorage.clear();
              this.initializeData();
              console.debug('Error: payment response data:', data);
              navigate('/error');
            }
            this.ajaxLoading = false;
          },
          () => {
            this.creditCardStorno();
            this.ajaxLoading = false;
          }
        );
      } else {
        errorMessages = [{ validierungsText: `${i18n('Kreditkartenzahlung fehlgeschlagen')}` }];
      }
    }

    const {
      personal: { type: payment_type, iban, bic }
    } = this.data;

    const { loading } = this.state;

    const props = {
      ...this.makeLinks(this.urls.personal, this.urls.summary, null),
      loading,
      iban,
      bic,
      payment_type,
      paymentPending: this.ajaxLoading,
      onRender: this.resetApiErrors,
      onConfirm: this.placeOrder,
      apiErrorMessages: errorMessages.length ? errorMessages : this.state.apiErrorMessages,
      onChange: partial(this.updateData, 'summary'),
      data: this.data.personal
    };

    return <Summary {...props} />;
  };

  creditCardStorno = () => {
    const { navigate } = this.props.router;

    this.handleCreditCardPayment(this.params, true).then(
      () => {
        sessionStorage.clear();
        navigate('/error');
      },
      () => {
        sessionStorage.clear();
        navigate('/error');
      }
    );
  };

  renderSuccessPage = () => {
    const { status } = this.state;

    if (!this.data.success) {
      return <Navigate replace to={this.urls.personal} />;
    }

    return (
      <PaymentSuccess
        status={status}
        onSuccess={() => {
          this.blockPayment = true;
        }}
        resetData={this.initializeData}
      />
    );
  };

  render() {
    const prefix = window.base === '/' ? '' : window.base;
    const { restored } = this.state;

    if (!restored) {
      return null;
    }

    return (
      <div className="online-premium-payment">
        <Head
          title={i18n('Online Prämienzahlung')}
          steps={this.steps}
          showSteps={window.location.pathname !== `${prefix}/success` && window.location.pathname !== `${prefix}/error`}
        />
        <Routes>
          <Route exact path={this.urls.personal} Component={this.renderPersonalDetailsPage} />
          <Route path={this.urls.summary} Component={this.renderSummaryPage} />
          <Route path={this.urls.success} Component={this.renderSuccessPage} />
          <Route path={this.urls.error} element={<PaymentError />} />
          <Route path="/" element={<Navigate replace to={this.urls.personal} />} />
        </Routes>
      </div>
    );
  }
}

export default withRouter(PaymentFormMkContainer);
